import { ReactPlugin as AppInsightsReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const testMode = process.env.REACT_APP_TEST;

declare global {
  interface Window {
    appConfig: {
      applicationInsights: {
        instrumentationKey?: string;
      };
    };
  }
}

export const initAppInsights = () => {
  const appInsightPlugin = new AppInsightsReactPlugin();

  const appInsights = new ApplicationInsights({
    config: {
      enableAutoRouteTracking: false,
      disableFetchTracking: false,
      extensions: [appInsightPlugin as any],
      instrumentationKey: testMode
        ? "ebdfa4ba-0f04-4f8a-a614-1297b92209e3" // local-env-ae-ai is used for testing
        : window.appConfig.applicationInsights.instrumentationKey
    }
  });
  appInsights.loadAppInsights();
  return appInsightPlugin;
};
